/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsnoneflagged2Inputs */

const en_signupsnoneflagged2 = /** @type {(inputs: Signupsnoneflagged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing flagged in this window.`)
};

const de_signupsnoneflagged2 = /** @type {(inputs: Signupsnoneflagged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts markiert in diesem Zeitraum.`)
};

/**
* | output |
* | --- |
* | "Nothing flagged in this window." |
*
* @param {Signupsnoneflagged2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsnoneflagged2 = /** @type {((inputs?: Signupsnoneflagged2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsnoneflagged2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsnoneflagged2(inputs)
	return de_signupsnoneflagged2(inputs)
});
export { signupsnoneflagged2 as "signupsNoneFlagged" }